import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

type BreadcrumbCustomRouteLabelContextValue = {
  customRouteLabel?: string;
  setCustomRouteLabel: (label: string | undefined) => void;
};

const BreadcrumbCustomRouteLabelContext = createContext<
  BreadcrumbCustomRouteLabelContextValue | undefined
>(undefined);

export const BreadcrumbCustomRouteLabelProvider: React.FC = ({ children }) => {
  const [customRouteLabel, setCustomRouteLabel] = useState<string>();
  const value = useMemo(() => ({ customRouteLabel, setCustomRouteLabel }), [
    customRouteLabel,
  ]);

  return (
    <BreadcrumbCustomRouteLabelContext.Provider value={value}>
      {children}
    </BreadcrumbCustomRouteLabelContext.Provider>
  );
};

export const useBreadcrumbCustomRouteLabel = () => {
  const context = useContext(BreadcrumbCustomRouteLabelContext);

  if (!context) {
    throw new Error(
      'useBreadcrumbCustomRouteLabel must be used within a BreadcrumbCustomRouteLabelProvider',
    );
  }

  return context;
};

// lets the view rendered for the current route supply its own text for its
// breadcrumb item (for example built from data the Breadcrumb component itself has
// no access to) instead of the item's static per-route label
export const useSetBreadcrumbCustomRouteLabel = (label: string | undefined) => {
  const { setCustomRouteLabel } = useBreadcrumbCustomRouteLabel();

  useEffect(() => {
    setCustomRouteLabel(label);

    return () => setCustomRouteLabel(undefined);
  }, [label, setCustomRouteLabel]);
};
